var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardCard',{attrs:{"title":"OS","content-padding":""},scopedSlots:_vm._u([{key:"content",fn:function(){return [(_vm.$route.name === 'home')?_c('VueApexChart',{attrs:{"height":"270","type":"donut","series":_vm.series,"options":_vm.options}}):_vm._e()]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }